import React from 'react';
import { TableRow } from '@mui/material';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import type { ICourtCaseRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/courtCases/types.ts';
import { financialConditionTableFieldStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';
import { normalizeDecimalValue } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';

export const CourtCaseRow: React.FC<ICourtCaseRowProps> = ({
  index,
  canRemove,
  disabled,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormInput
        name={`courtCases.${index}.otherParty`}
        label="Інша сторона"
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`courtCases.${index}.borrowerName`}
        label="Найменування позичальника"
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`courtCases.${index}.borrowerStatus`}
        label="Статус позичальника"
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`courtCases.${index}.subject`}
        label="Предмет спору"
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`courtCases.${index}.claimAmount`}
        label="Сума позову, тис. од."
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`courtCases.${index}.claimDate`}
        label="Дата позову"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`courtCases.${index}.currentState`}
        label="Поточний стан справи"
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити судову справу ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
